var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input',{directives:[{name:"cleave",rawName:"v-cleave",value:(_vm.mask),expression:"mask"}],attrs:{"value":_vm.innerValue,"maxlength":"250"}})}
var staticRenderFns = []

export { render, staticRenderFns }